import { ArticuloRutas, GetResponseBody, GetHeaderRequest } from './RutasConfig';

export const Validar_Articulo_Despacho_Request = async (pToken, pEmpresa_Id, pArticulo_Id, pArticulo_Id_Validar) => {
    const data = { Emp_Id: pEmpresa_Id, Articulo_Id: pArticulo_Id, Articulo_Id_Validar: pArticulo_Id_Validar };
    const result = await fetch(ArticuloRutas.Validar_Articulo_Despacho, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};